import { AutogenLayoutEdiReplyCodePartners } from "./autogen/AutogenLayoutEdiReplyCodePartners";
import { LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { EdiPartnerQualifiersHelper } from "./EdiPartnerQualifiersBase";

export class EdiReplyCodePartners extends AutogenLayoutEdiReplyCodePartners {
    private _replyPartnerId: string;
    private _replyVersion: string;

    setPartnerValues(replyPartnerId: string, replyVersion: string) {
        this.replyPartnerId = replyPartnerId;
        this.replyVersion = replyVersion;
    }

    setColumnsForTender() {
        const columnsToRemove = ["columnHeaderFault", "columnIncludePickups", "columnIncludeDeliveries", "columnHeaderSendToDriver"];
        EdiPartnerQualifiersHelper.setColumnsForTender(this.tablePartnerQualifiers, columnsToRemove);
    }

    async disableButtonOnClick() {
        await EdiPartnerQualifiersHelper.setRecordsOnClick(
            this.tablePartnerQualifiers,
            this.mainDataSource,
            false,
            "Are you sure you want to disable all reply codes?",
            this.buttonDisableAll
        );
    }

    async enableButtonOnClick() {
        await EdiPartnerQualifiersHelper.setRecordsOnClick(
            this.tablePartnerQualifiers,
            this.mainDataSource,
            true,
            "Are you sure you want to enable all reply codes?",
            this.buttonEnableAll
        );
    }

    returnFormattedRows() {
        return EdiPartnerQualifiersHelper.returnFormattedRows(this.tablePartnerQualifiers);
    }

    beforeStandardCodeLookup(event: LookupModelSearchEvent) {
        EdiPartnerQualifiersHelper.setupLookupFilter(event, this.replyPartnerId, this.replyVersion, true);
    }

    standardCodeOnLookupModelSearch(event: LookupModelSelectionEvent) {
        EdiPartnerQualifiersHelper.handleLookupSelection(event, this.replyPartnerId, this.replyVersion);
    }

    get replyPartnerId(): string {
        return this._replyPartnerId;
    }

    set replyPartnerId(value: string) {
        this._replyPartnerId = value;
    }

    get replyVersion(): string {
        return this._replyVersion;
    }

    set replyVersion(value: string) {
        this._replyVersion = value;
    }
}